var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    width: 14,
    height: 14,
    rx: 3,
    fill: "#D90000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1895 3.80571L10.3837 3L7.18945 6.19429L3.99517 3L3.18945 3.80571L6.38374 7L3.18945 10.1943L3.99517 11L7.18945 7.80571L10.3837 11L11.1895 10.1943L7.99517 7L11.1895 3.80571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.cbf1aa61caa7a07d1da2b12d6a966c71.svg";
export { ForwardRef as ReactComponent };